import React from "react";
import * as S from "./statusBadge.styles";

export interface StatusBadgeProps {
  status: "canceling" | "pending" | "completed" | "error";
  message?: string;
}

export const StatusBadge = ({ status, message }: StatusBadgeProps) => {
  const getStatusConfig = () => {
    switch (status) {
      case "canceling":
        return {
          label: "운송 취소 요청중입니다",
          icon: "⏳",
          color: "canceling" as const,
        };
      case "pending":
        return {
          label: "처리 대기중입니다",
          icon: "⏰",
          color: "info" as const,
        };
      case "completed":
        return {
          label: "처리 완료되었습니다",
          icon: "✅",
          color: "success" as const,
        };
      case "error":
        return {
          label: "처리 중 오류가 발생했습니다",
          icon: "❌",
          color: "error" as const,
        };
      default:
        return {
          label: "알 수 없는 상태입니다",
          icon: "❓",
          color: "info" as const,
        };
    }
  };

  const config = getStatusConfig();

  return (
    <S.StatusBadgeContainer color={config.color}>
      <S.StatusIcon>{config.icon}</S.StatusIcon>
      <S.StatusText color={config.color}>
        {message || config.label}
      </S.StatusText>
    </S.StatusBadgeContainer>
  );
};
